import { keepOneNull } from '@/utils/utils';
import dayjs from 'dayjs';
import * as echarts from 'echarts';

export const getChartOption = (data: any[]) => {
  const areaColors = [
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      { offset: 0, color: '#16DD8E20' },
      { offset: 1, color: '#16DD8E10' },
    ]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      { offset: 0, color: '#FFCB4720' },
      { offset: 1, color: '#FFCB4710' },
    ]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      { offset: 0, color: '#2D8DFF20' },
      { offset: 1, color: '#2D8DFF10' },
    ]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      { offset: 0, color: '#CE90D120' },
      { offset: 1, color: '#CE90D110' },
    ]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      { offset: 0, color: '#FF477B20' },
      { offset: 1, color: '#FF477B10' },
    ]),
  ];

  const series = data.map((item, index) => {
    return {
      name: item.name,
      type: 'line',
      data: item.powerList.map((m: any) => [dayjs(m.ts).valueOf(), keepOneNull(m.value)]),
      connectNulls: true,
      smooth: true,
      showSymbol: false,
      areaStyle: {
        color: areaColors[index],
      },
    };
  });

  return {
    backgroundColor: '#162235',
    color: ['#16DD8E', '#FFCB47', '#2D8DFF', '#CE90D1', '#FF477B'],
    tooltip: {
      formatter: (items: any) => {
        let { axisValue } = items[0];
        let firstStr = dayjs(axisValue).format('YYYY-MM-DD HH:mm:ss');
        let tableRows = '';

        items.forEach((item: any, index: number) => {
          const { seriesName, data, marker } = item;
          const value = data[1] || data[1] === 0 ? data[1] : '-';
          tableRows += `<tr><td style="padding-right: 10px;"><span>${marker}</span>${seriesName}</td><td style="text-align: right;">${value}kW</td></tr>`;
        });

        return `${firstStr}<table style="margin-top: 8px; border-collapse: collapse;">${tableRows}</table>`;
      },
    },
    grid: {
      left: 10,
      right: 10,
      top: 40,
      bottom: 10,
      containLabel: true,
    },
    xAxis: [
      {
        type: 'time',
        axisLabel: {
          formatter: function (e: number) {
            return dayjs(e, 'x').format('HH:mm');
          },
        },
      },
    ],
    yAxis: [
      {
        type: 'value',
        name: 'kW',
        axisLabel: {
          formatter: '{value}',
        },
      },
    ],
    series,
  };
};
